export function isMemberAddressLocationResponse(v) {
    if (!v || typeof v !== 'object')
        return false;
    const x = v;
    return (typeof x.memberId === 'string' &&
        (x.address === null ||
            (typeof x.address.id === 'string' &&
                typeof x.address.primaryStreet === 'string' &&
                Number.isInteger(x.address.version))) &&
        (x.location === null ||
            (typeof x.location.id === 'string' &&
                Number.isFinite(x.location.latitude) &&
                Number.isFinite(x.location.longitude) &&
                typeof x.location.mapsUrl === 'string' &&
                Number.isInteger(x.location.version))) &&
        Array.isArray(x.history?.addresses) &&
        Array.isArray(x.history?.locations));
}
